import { Grid } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router-dom";
import { Loader, NoEposterData } from ".";
import CardItem from "./CardItem";

const EPostersFavouriteGrid = ({ loading, ePosters, isEditable, onEdit }) => {
  const history = useHistory();
  const onEPosterClick = id => () => {
    history.push(`/e-posters/${id}`);
  };

  return (
    <Loader loading={loading}>
      <NoEposterData data={ePosters}>
        <Grid container spacing={3}>
          {ePosters.map(({ id, title, eposterAccademics, thumbUrl, favouritableId }) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={id}>
              <CardItem
                title={title}
                description={(eposterAccademics || [])
                  .map(ea =>
                    `${ea.profile.title || ""} ${ea.profile.firstName} ${
                      ea.profile.lastName
                    }`.trim()
                  )
                  .join(", ")}
                thumbUrl={thumbUrl}
                onClick={onEPosterClick(id)}
                isEditable={isEditable}
                onEdit={e => {
                  onEdit(e, { favouritableId });
                  e.preventDefault();
                  e.stopPropagation();
                }}
              />
            </Grid>
          ))}
        </Grid>
      </NoEposterData>
    </Loader>
  );
};

export default EPostersFavouriteGrid;
